module.exports = __webpack_public_path__ + "img/service_top.2f7d172d.jpg";